import "./techs.css";
import gif from "../../Assets/img/giphy.gif"

const Techs = () => {
  return (
    <div className="containerTech">
      <div className="logoReact">
        <div className="imgTech">
          <span className="techs"></span>
          <span className="techs"></span>
          <span className="techs"></span>
          <span className="techs"></span>
          <span className="techs"></span>
          <span className="techs"></span>
          <span className="techs"></span>
          <span className="techs"></span>
        </div>
        <img src={gif} alt="simbolo do react" />
      </div>
    </div>
  );
};

export default Techs;
